module.exports = __webpack_public_path__ + "static/img/conference_logo.2cc272fb.png";